import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { APP_INITIALIZERS } from '@app/app-initializers';
import { routes } from '@app/app.routes';
import { AppErrorHandler } from '@app/shared/http-service/error.handler';
import { HttpAppInterceptor } from '@app/shared/http-service/http.app.interceptor';
import { HttpTenantAuthorizationInterceptor } from '@app/shared/http-service/http.tenant-authorization.interceptor';
import { RateLimitInterceptor } from '@app/shared/http-service/rate-limit.interceptor';
import { provideIcons } from '@app/shared/icon.config';
import { provideGlobalPipes } from '@app/shared/pipes/provide-global-pipes';
import PrimeNgConfig from '@app/shared/primeng/config/primeng-config';
import { I18nService } from '@app/shared/services/i18n.service';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { NgEventBus } from 'ng-event-bus';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';

export const appConfig: ApplicationConfig = {
	providers: [
		{
			provide: ErrorHandler,
			useClass: AppErrorHandler
		},
		...APP_INITIALIZERS,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpAppInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpTenantAuthorizationInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RateLimitInterceptor,
			multi: true
		},
		{
			provide: LOCALE_ID,
			useFactory: (i18nService: I18nService) => i18nService.locale,
			deps: [I18nService],
		},
		CookieService,
		DialogService,
		MessageService,
		NgEventBus,
		provideGlobalPipes(),
		provideAnimationsAsync(),
		provideIcons(),
		provideRouter(routes),
		provideOAuthClient(),
		provideHttpClient(withInterceptorsFromDi()),
		provideZonelessChangeDetection(),
		providePrimeNG(PrimeNgConfig)
	]
};